import {observer} from 'mobx-react';
import Celebration from './Celebration';
import {FormattedMessage} from 'react-intl';

const Anniversary = observer(({anniversary, Emoji}) => {
  return (
    <Celebration
      employee={anniversary.employee}
      date={anniversary.publishedAt}
    >
      <FormattedMessage
        id='hr_dashboard.feed.celebrations.ANNIVERSARY_MESSAGE'
        values={{
          link: <a href={`/employees/${anniversary.employee.id}`}>
                  {anniversary.employee.name}
                </a>,
          numberOfYears: anniversary.numberOfYears
        }}
      />
      {Emoji && <span className='ml1'>
        <Emoji emoji={'tada'} size={22}/>
      </span>}
    </Celebration>
  );
});

export default Anniversary;
